import { createContext } from 'react';

const modeloContext = createContext();

export default modeloContext;